// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1gEcX","data":"Card_data__2QD4B","del":"Card_del__1gavU","span":"Card_span__3HjxN","buttonaction":"Card_buttonaction__2xvkY"};